import {createAction} from 'redux-actions';
import * as ACTION from '../constants';

export const updateWarehouse = createAction(ACTION.UPDATE_WAREHOUSE.REQUEST, (params) => ({...params}));
export const clearState = createAction(ACTION.CLEAR_STATE);
